export function memoize<T>(
  items: T[],
  key: keyof T | ((item: T) => string) = 'id' as keyof T,
) {
  let fn: (item: T) => string;
  if (
    typeof key === 'string' ||
    typeof key === 'symbol' ||
    typeof key === 'number'
  ) {
    fn = (item: T) => item[key as keyof T] as string;
  } else {
    fn = key;
  }

  const out: Record<string, T> = {};
  for (const item of items) {
    const k = fn(item);
    out[k] = item;
  }

  return out;
}
